module.exports = __webpack_public_path__ + "img/sld_metering_panel_em.6bbe8646.svg";